import * as React from 'react';
import FacetHeader from './FacetHeader/FacetHeader.js';

const FacetContainer = ({ title , SearchButton , ClearButton , children ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-container"
    }, /*#__PURE__*/ React.createElement(FacetHeader, {
        title: title,
        SearchButton: SearchButton,
        ClearButton: ClearButton
    }), /*#__PURE__*/ React.createElement("div", {
        className: "facet-container__inner"
    }, children));
};

export { FacetContainer as default };
//# sourceMappingURL=FacetContainer.js.map
